import { render, staticRenderFns } from "./archiveList.vue?vue&type=template&id=a88d969a&scoped=true&"
import script from "./archiveList.vue?vue&type=script&lang=js&"
export * from "./archiveList.vue?vue&type=script&lang=js&"
import style0 from "./archiveList.vue?vue&type=style&index=0&id=a88d969a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88d969a",
  null
  
)

export default component.exports